import React, { useState } from "react";
import axios from "axios";
import "./Weather.css";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
    const [weatherData, setWeatherData] = useState({ ready: false});
    const [city, setCity] = useState(props.defaultCity);
    function handleResponse(response){
        console.log(response.data);
        setWeatherData({
            ready: true,
            coord: response.data.coord,
            temperature: response.data.main.temp,
            wind: response.data.wind.speed,
            city: response.data.name,
            humidity: response.data.main.humidity,
            description: response.data.weather[0].description,
            icon: response.data.weather[0].icon,
            date: new Date(response.data.dt*1000)
        });
    }

    function handleSubmit(event){
        event.preventDefault();
        search(city);
    }

    function search() {
        const apiKey = '7e2d6c3d38a855b033f6e213b1c9eca4';
        let apiURL = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
        axios.get(apiURL).then(handleResponse);
    }

    function handleCityChange(event){
        setCity(event.target.value);
    }

    if(weatherData.ready) {
        return (
        <div className = "Weather">
            <div className="container-two">
                <form onSubmit={handleSubmit}>
                    <div class="row">
                        <div className="col-9">
                            <input type="search" placeholder="Search" className ="form-control" autofocus="on" onChange={handleCityChange} />
                        </div>
                        <div className="col-3">
                            <input type="submit" className = "btn btn-primary w-100" />
                        </div>
                    </div>
                </form>
                <WeatherInfo data={weatherData}/>
                <WeatherForecast coordinates={weatherData.coord}/>
            </div>
        </div>
        );
    } else {
        search();
        return "Loading...";
    }
    
}